import {
  Button,
  Pagination,
  Popconfirm,
  Space,
  Table,
  Tag,
  Tooltip,
} from "antd";
import type { ColumnsType } from "antd/es/table";
import moment from "moment";
import { IoTrashOutline } from "react-icons/io5";
import { MdPreview } from "react-icons/md";
import { LuUndo2 } from "react-icons/lu";
import { useSelector } from "react-redux";
import { BiEdit } from "react-icons/bi";
import { IoEyeSharp } from "react-icons/io5";

function DataTable(props: any) {
  const User = useSelector((state: any) => state.User.user);
  interface DataType {
    key: string;
    id: number;
    edition: string;
    image: string;
    attributes: JSON;
  }

  const epaperColumns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 10,
      render: (text, record, index) => {
        return <strong>{index + 1}.</strong>;
      },
    },
    {
      title: "Preview",
      key: "image",
      dataIndex: "image",
      width: 20,
      render: (text, record: any) => {
        return (
          <div>
            {record?.image ? (
              <img
                key={record?.image}
                src={record?.image}
                alt="Table Image"
                style={{ height: 40, borderRadius: 6 }}
              />
            ) : (
              <div className="homescreen-table-NoImg">No media</div>
            )}
          </div>
        );
      },
    },
    {
      title: "Edition",
      dataIndex: "edition",
      key: "edition",
      width: 130,
      render: (text, record: any, index) => {
        return <div>{record?.edition}</div>;
      },
    },
    {
      title: "Created By",
      dataIndex: "username",
      key: "username",
      width: 130,
      render: (text, record: any) => {
        return <div>{record?.user?.username}</div>;
      },
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: 100,
      render: (text, record: any, index) => {
        return <div>{moment(record?.date).format("DD-MM-YYYY")}</div>;
      },
    },
    {
      title: "No.Pages",
      width: 80,
      render: (text, record: any, index) => {
        return (
          <div>
            <strong>{record?.epapercollections?.length}</strong> Pages
          </div>
        );
      },
    },
    {
      title: "Published Date & Time",
      dataIndex: "publishedAt",
      key: "publishedAt",
      width: 180,
      render: (text, record: any, index) => {
        return record?.publishedAt ? (
          <div style={{ paddingLeft: "10px" }}>
            <div>{moment(record.publishedAt).format("DD-MM-YYYY")}</div>
            <div style={{ fontSize: "12px", color: "#666" }}>
              {moment(record.publishedAt).format("h:mm A")}
            </div>
          </div>
        ) : record?.scheduledAt ? (
          <Tag color="gold">
            {moment(record.scheduledAt).format("DD-MM-YYYY h:mm A")}
          </Tag>
        ) : (
          <div style={{ color: "#999", fontSize: "12px", paddingLeft: "10px" }}>
            Not Published
          </div>
        );
      },
    },
    {
      title: "Status",
      width: 30,
      render: (text, record: any, index) => {
        return record?.publishedAt ? (
          <Tag color="green">Published</Tag>
        ) : record?.scheduledAt ? (
          <Tag color="orange">Scheduled</Tag>
        ) : (
          <Tag color="blue">Draft</Tag>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      width: 10,
      render: (_, record: any) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignContent: "center",
              gap: 20,
            }}
          >
            <Space size="middle" onClick={() => props.showPreview(record)}>
              <IoEyeSharp size={20} cursor={"pointer"} color="black" />
            </Space>
            <Space>
              <BiEdit
                size={20}
                color="blue"
                cursor={"pointer"}
                onClick={() => props.onEdit(record)}
              />
            </Space>
            <Space size="middle" style={{ marginRight: 10 }}>
              <Tooltip
                title={`${
                  record?.is_deleted === true ? "Recover" : "Move"
                } From Trash`}
                color={"black"}
              >
                {record?.is_deleted === true ? (
                  <LuUndo2
                    color="blue"
                    size={20}
                    cursor={"pointer"}
                    onClick={() => props.unTrash(record)}
                  />
                ) : (
                  <IoTrashOutline
                    color="red"
                    size={20}
                    cursor={"pointer"}
                    onClick={() => props.onTrash(record)}
                  />
                )}
              </Tooltip>
            </Space>
            {record?.is_deleted === true && User?.role?.id === 4 ? (
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => props.onDelete(record?.id)}
              >
                <Button size="small" danger style={{ fontSize: 12 }}>
                  Remove
                </Button>
              </Popconfirm>
            ) : null}
          </div>
        );
      },
    },
  ];

  const dateColumns: ColumnsType<any> = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: 200,
      render: (text, record: any) => {
        return <div>{moment(record?.date).format("DD-MM-YYYY")}</div>;
      },
    },
    {
      title: "Action",
      key: "action",
      width: 10,
      render: (_, record: any) => {
        return (
          <Space size="middle">
            <Button
              type="default"
              size="small"
              onClick={() => {
                const date = record?.date;
                if (date && props.onSelectDate) {
                  props.onSelectDate(date);
                }
              }}
            >
              View
            </Button>
          </Space>
        );
      },
    },
  ];

  return (
    <div>
      <Table
        columns={props.mode === "date" ? dateColumns : epaperColumns}
        dataSource={props.data}
        pagination={false}
        size="small"
        rowKey={(record: any) =>
          props.mode === "date"
            ? String(record?.date || Math.random())
            : String(record?.id || Math.random())
        }
      />
      <br />
      <div style={{ float: "right" }}>
        <Pagination
          responsive
          defaultCurrent={props?.page}
          total={props?.meta}
          pageSize={props?.pagesize}
          onChange={props.onPageChange}
        />
      </div>
    </div>
  );
}

export default DataTable;
